import { useAuth, API } from "@/App";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SignOut, List, User, Anchor } from "@phosphor-icons/react";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-200" data-testid="app-header">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-14 flex items-center justify-between">
        {/* Left - logo */}
        <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-testid="header-logo-link">
          <img
            src="https://www.cargo-cfs.com/wp-content/uploads/2020/08/prenos.jpg"
            alt="Cargo CFS"
            className="h-7 object-contain"
          />
          <span className="hidden sm:block text-xs font-semibold uppercase tracking-[0.15em] text-slate-500 border-l border-slate-200 pl-3 ml-1">
            Reporting System
          </span>
        </Link>

        {/* Right */}
        <div className="flex items-center gap-3">
          <div className="hidden md:flex items-center gap-2 text-sm text-slate-600">
            <User size={16} weight="fill" className="text-blue-900" />
            <span>{user?.name || user?.email}</span>
            <span className="text-xs px-1.5 py-0.5 bg-slate-100 text-slate-500 rounded capitalize">{user?.role}</span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            className="text-slate-500 hover:text-slate-900 gap-1.5"
            data-testid="logout-btn"
          >
            <SignOut size={16} /> Sign Out
          </Button>
        </div>
      </div>
    </header>
  );
}
